var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"outreach-stasge-segments"},[_c('list-tag',{attrs:{"tags":_vm.stagesData,"type":_vm.OUT_REACH_TAG_TYPE.STAGE}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }